import { useAppSelector } from "../../../../hooks";
import {
  useReplyPathContext,
  OPENED_REPLY_MESSAGE_HEIGHT,
} from "../../contexts";

import { selectAuthorList } from "../../selectors";
import { getAuthor } from "../chat-message/get-author";
import { isMessageFile } from "../../type-guards";
import { Reply } from "./partials";
import type { ReplyMessage } from "../../types";

type Props = {
  parentId: string;
  message: ReplyMessage;
};

export const ChatMessageReply = ({ parentId, message }: Props) => {
  const { handleClickOnReplyMessage } = useReplyPathContext();
  const authorList = useAppSelector(selectAuthorList);

  if (!message) {
    return null;
  }

  const replyAuthor = getAuthor(authorList, message);
  const { first, last } = replyAuthor.name;
  const replyAuthorName = `${first} ${last}`;

  const text = isMessageFile(message)
    ? message.content.text || message.content.file.name
    : message.content.text;

  const handleClick = () => handleClickOnReplyMessage(message.id, parentId);

  return (
    <Reply
      showIcon={false}
      name={replyAuthorName}
      text={text}
      height={OPENED_REPLY_MESSAGE_HEIGHT}
      dataTestId="chat-message-content-reply"
      onClick={handleClick}
    />
  );
};
